document.addEventListener('DOMContentLoaded', function () {
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error) {
      console.error('Failed to load consent-tracking-api:', error);
      return;
    }

    document.addEventListener('click', function (e) {
      const target = e.target.closest('a[href*="#open-cookie-settings"]');

      if (target) {
        e.preventDefault();
        e.stopPropagation();

        showCookiePreferences();
      }
    });
  });
});

function showCookiePreferences() {
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    window.privacyBanner.showPreferences().then(() => {
      console.log('Cookie preferences modal opened');
    });
  }
}
